import { API_BASE_URL } from './config';
import { Product } from '../data/products';

type ApiProduct = {
  id: string;
  name: string;
  description: string;
  price: number;
  image: string;
  category: string;
  features: string[];
  inStock: boolean;
};

function toProduct(p: ApiProduct): Product {
  return {
    id: p.id,
    name: p.name,
    description: p.description,
    price: p.price,
    image: p.image || '',
    category: p.category,
    features: p.features || [],
    inStock: p.inStock,
  };
}

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE_URL}${path}`);
  if (!res.ok) {
    throw new Error(`API ${res.status}: ${path}`);
  }
  return res.json() as Promise<T>;
}

export async function fetchProductsByCategory(category: string): Promise<Product[]> {
  const query = category ? `?category=${encodeURIComponent(category)}` : '';
  const data = await getJson<ApiProduct[]>(`/api/products${query}`);
  return data.map(toProduct);
}

export async function fetchProductById(id: string): Promise<Product | null> {
  try {
    const data = await getJson<ApiProduct>(`/api/products/${encodeURIComponent(id)}`);
    return toProduct(data);
  } catch {
    return null;
  }
}
